import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Params, ActivatedRoute, Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';
import { TextTools } from 'appshared/text-tools';
import { SharedLicenseTools } from 'appshared/shared-license-tools';
import { LicenseValidationTools } from 'appshared/license-validation-tools';

import { AuthService } from 'client/app/services/auth.service';
import { LoginLogsService } from '../../login-logs/login-logs.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';

@Component({
	selector: 'app-extras',
	templateUrl: './extras.component.html',
	styleUrls: ['./extras.component.scss']
})
export class ExtrasComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	mt = MiscTools;
	tt = TextTools;

	refreshing = true;
	private userSubscription: Subscription;
	private authUser: Models.AuthUser;

	locationCounts: any = [];
	imgWidth: number = 50;
	daysBack: number = 365;
	mode: string = 'city';
	success: string = 'success-std';

	constructor(
		private router: Router,
		private authService: AuthService,
		private uiAlertsService: UiAlertsService,
		private loginLogsService: LoginLogsService
	) { }

	// ********************************************************
	ngOnInit(): void {
		this.userSubscription = this.authService.user.subscribe(authUser => {
			this.authUser = authUser;
			if (authUser) {
				this.loadData();
			}
		});
	}

	// ********************************************************
	ngOnDestroy() {
		if (this.userSubscription) this.userSubscription.unsubscribe();
	}

	// ********************************************************
	async loadData(forceRefresh = false) {
		this.refreshing = true;

		const flagBase: string = 'https://assets.ipstack.com/flags';

		const tmpCounts: any[] = await this.loginLogsService.getLoginCounts(this.daysBack, this.success);
		if (this.mode === 'city') {
			for (const item of tmpCounts) {
				const location: string = item['location'] ? item['location'] : '';
				const parts: string[] = TextTools.trimList(location.split(','));
				if (parts.length > 1) {
					const country: string = parts[parts.length - 1];
					const prov: string = parts[parts.length - 1];
					item['__flag'] = AppConstants.flagBase + '/' + country.toLowerCase() + '.svg';
				} // if
			} // for
			tmpCounts.sort((a, b) => (a['location'] > b['location']) ? 1 : -1);
			for (const item of tmpCounts)
				item['imgWidth'] = this.imgWidth;
			this.locationCounts = tmpCounts;

		} else if (this.mode === 'province') {
			const regionCounts: any[] = [];
			for (const item of tmpCounts) {
				const location: string = item['location'] ? item['location'] : '';
				const parts: string[] = TextTools.trimList(location.split(','));
				if (parts.length > 2) {
					const country: string = parts[parts.length - 1];
					const prov: string = parts[parts.length - 2];
					const key: string = prov + ', ' + country;
					const idx: number = MiscTools.findIndexGeneric(regionCounts, 'location', key);
					if (idx === -1)
						regionCounts.push({ location: key, theCount: +item.theCount, '__flag': flagBase + '/' + country.toLowerCase() + '.svg' });
					else
						regionCounts[idx].theCount = regionCounts[idx].theCount + +item.theCount;
				} // if
			} // for
			for (const item of regionCounts)
				item['imgWidth'] = this.imgWidth;

			regionCounts.sort((a, b) => (a['location'] > b['location']) ? 1 : -1);
			this.locationCounts = regionCounts;

		} else if (this.mode === 'country') {
			let inCount: number = 0;
			let outCount: number = 0;

			const regionCounts: any[] = [];
			for (const item of tmpCounts) {
				const location: string = item['location'] ? item['location'] : '';
				const parts: string[] = TextTools.trimList(location.split(','));
				if (parts.length > 1) {
					const country: string = parts[parts.length - 1];
					const key: string = country;
					const idx: number = MiscTools.findIndexGeneric(regionCounts, 'location', key);
					if (idx === -1)
						regionCounts.push({ location: key, theCount: +item.theCount, '__flag': flagBase + '/' + country.toLowerCase() + '.svg' });
					else
						regionCounts[idx].theCount = regionCounts[idx].theCount + +item.theCount;
					inCount++;
				} else {
					outCount++;
				} // if
			} // for

			for (const item of regionCounts)
				item['imgWidth'] = this.imgWidth + Math.floor(item.theCount / 100);

			regionCounts.sort((a, b) => (+a['theCount'] < +b['theCount']) ? 1 : -1);
			this.locationCounts = regionCounts;

		} // if



		this.refreshing = false;
	}

}
